<svelte:options customElement="policies-main" />

<script>
	import { onMount } from "svelte";
	import { loadAssets, baseUrl } from "../../../../../SharedSvelte/Common.svelte";
	import { Loader } from "../../../../../SharedSvelte/GlobalLoader.svelte";
	import { appClinicalPoliciesState } from "../../state/ApplicationState.svelte";
	import GlobalLoader from "../../../../../SharedSvelte/GlobalLoader.svelte";	
	import ClinicalPolicies from './ClinicalPolicies.svelte';
	import { Alert, Icon } from '@sveltestrap/sveltestrap';

	async function fetchClinicalPoliciesContent() {
	    Loader.display();
	    const response = await fetch(`${baseUrl}Options/ClinicalPolicies/ClinicalPoliciesContent`, {
	        method: 'POST',
	        headers: {
	        'Content-Type': 'application/json',
	        '__RequestVerificationToken': document.getElementsByName("__RequestVerificationToken")[0].value
	        },
	    });
	    window.scrollTo(0, 0);
	    if (response.ok) {
	        const data = await response.json();
	        appClinicalPoliciesState.clinicalPolicies = data.clinicalPolicies;			
	        } 
			else {
                throw new Error(`Error ${response.status}: ${response.statusText}`);	           
	        }
	    Loader.hide();
	}

	function showPolicies(event) {
		event.preventDefault();       
		fetchClinicalPoliciesContent();
		appClinicalPoliciesState.signedAgreement = true;
        window.scrollTo(0, 0);
	}   

	onMount(() => {
		setTimeout(() => {
		loadAssets("policies-main");
		// setTimeout( function() { fetchClinicalPoliciesContent() }, 100 );
		}, 10);
	});
</script>

<main class="mb-3">
	{#if appClinicalPoliciesState.signedAgreement}
		<ClinicalPolicies />
	{:else}
			<h2>CLINICAL POLICIES TERMS AND CONDITIONS</h2>
            <strong>Disclaimer:</strong>
            <p>
				PEHP clinical policies are designed to assist providers in understanding what PEHP considers to be "medically necessary"
                under the terms and conditions of the PEHP Master Policy and do not constitute medical advice.
                Treating providers are solely responsible for medical advice and treatment of PEHP members.
            </p>
            <p>
				Although PEHP Clinical Policies are intended to assist in understanding plan benefit, they are
                NOT a description of plan benefits and services may not be covered by PEHP even if medically necessary.
                For a full-description of plan benefits, please see the applicable PEHP Master Policy.
            </p>
            <p>Please note also that PEHP clinical policies are regularly updated and are therefore subject to change without notice.</p>
            <center>                                     
				<button class="btn btn-primary btn-lg mt-2 mb-2" onclick={showPolicies}>I agree to these terms and conditions</button>                    
            </center>				 
	{/if}
</main>

<GlobalLoader />